export const isProd = true;

export const API_URL = isProd 
  ? 'https://api.read-2-me.net:8443'  // Add :8443 here
  : 'http://localhost:5000';

export default API_URL;